var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loadingMask flex items-center justify-center"},[_vm._t("default",function(){return [_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading flex-1",attrs:{"element-loading-text":_vm.text}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }